import React from "react";
import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

import BounceIcon from "components/common/icons/BounceIcon";
import styles from "./animation.module.scss";

interface AnimationButtonProps {
  onShowAnimations: () => void;
}

const AnimationButton: React.FC<AnimationButtonProps> = ({ onShowAnimations }) => (
  <Button inverted onClick={onShowAnimations} className={styles.TriggerButton}>
    <BounceIcon /> <Trans>Animations</Trans>
  </Button>
);

export default AnimationButton;
